import React, { useEffect } from 'react'
import Joi, { ValidationError } from 'joi'

function useDataValidation<DataType>(
  schema: Joi.AnySchema,
  data: DataType
): [DataType | undefined, ValidationError | undefined] {
  const [validatedData, setValidatedData] = React.useState<DataType>()
  const [validationError, setValidationError] =
    React.useState<ValidationError>()
  useEffect(() => {
    if (!data) {
      return
    }

    schema
      .validateAsync(data)
      .then(joiValidatedData => setValidatedData(joiValidatedData))
      .catch(err => setValidationError(err))
  }, [data])
  return [validatedData, validationError]
}

export default useDataValidation
